import { useSelector } from "react-redux";
import useSWR from "swr";
import FriendChip from "./FriendChip";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

export default function ActiveFriendsChips({
  style,
}: {
  style?: React.CSSProperties;
}) {
  const userState = useSelector((state: any) => state.user);

  const { data } = useSWR<string[]>(
    `${process.env.REACT_APP_API_URL}/users/friends/drinking`,
    fetcher(userState.token),
    { refreshInterval: 10000 }
  );

  return (
    <>
      {data && data.length > 0 && (
        <div
          style={{
            display: "flex",
            gap: "1.5rem",
            overflowX: "auto",
            ...style,
          }}
        >
          {(data ?? []).map((userId) => (
            <FriendChip userId={userId} key={userId} />
          ))}
        </div>
      )}
    </>
  );
}
